import { render } from "./ToggleBullet.vue?vue&type=template&id=560873da"
import script from "./ToggleBullet.vue?vue&type=script&lang=js"
export * from "./ToggleBullet.vue?vue&type=script&lang=js"
script.render = render

export default script